var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.674 11.837a6.837 6.837 0 1 1-13.674 0 6.837 6.837 0 0 1 13.674 0Zm7.256 0c0 3.622-1.5 6.558-3.349 6.558-1.85 0-3.348-2.936-3.348-6.558S15.732 5.28 17.58 5.28c1.85 0 3.35 2.936 3.35 6.558Zm1.814 5.721c.694 0 1.256-2.624 1.256-5.86 0-3.237-.562-5.86-1.256-5.86-.693 0-1.256 2.623-1.256 5.86 0 3.236.563 5.86 1.256 5.86Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.d52edc25e9c409e835a58a694b34f779.svg";
export { ForwardRef as ReactComponent };